// extracted by mini-css-extract-plugin
module.exports = {"colorPickerContainer":"TextAreaDialog_colorPickerContainer__2u1k3","colorBox":"TextAreaDialog_colorBox__1cFCm"};